export default __webpack_public_path__ + "static/media/app-store.c5d657a5.svg";